import { ActionType } from '@/actions';
import { ActionSetWeeklySubscription } from './interfaces';

export const toggleWeeklySubscription = (
  game: number
): ActionSetWeeklySubscription => {
  return {
    type: ActionType.WEEKLY_SUBSCRIPTION_TOGGLE,
    game,
  };
};
